export default __webpack_public_path__ + "static/media/app-database.f1c49d27.jpg";